import React from 'react';
import { DollarSign, Clock } from 'lucide-react';
import { StandardButton } from '../../components/standard';

interface DebtSettlementDashboardProps {
  onBackToDashboard: () => void;
}

const DebtSettlementDashboard: React.FC<DebtSettlementDashboardProps> = ({ onBackToDashboard }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center text-white">
              <DollarSign className="h-6 w-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Debt Settlement</h1>
              <p className="text-gray-600 dark:text-gray-400">Negotiate and reduce outstanding debt balances</p>
            </div>
          </div>
          <StandardButton
            variant="secondary"
            onClick={onBackToDashboard}
          >
            Back to Dashboard
          </StandardButton>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg text-center">
            <h3 className="font-semibold text-purple-900 dark:text-purple-300">Active Cases</h3>
            <p className="text-2xl font-bold text-purple-800 dark:text-purple-400">0</p>
          </div>
          <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg text-center">
            <h3 className="font-semibold text-green-900 dark:text-green-300">Settled</h3>
            <p className="text-2xl font-bold text-green-800 dark:text-green-400">0</p>
          </div>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg text-center">
            <h3 className="font-semibold text-blue-900 dark:text-blue-300">In Negotiation</h3>
            <p className="text-2xl font-bold text-blue-800 dark:text-blue-400">0</p>
          </div>
        </div>

        {/* Coming Soon Placeholder */}
        <div className="bg-purple-50 dark:bg-purple-900/20 border-2 border-dashed border-purple-300 dark:border-purple-600 rounded-lg p-12 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-purple-100 dark:bg-purple-800 rounded-full flex items-center justify-center">
              <Clock className="h-8 w-8 text-purple-600 dark:text-purple-300" />
            </div>
          </div>
          <h2 className="text-xl font-bold text-purple-900 dark:text-purple-300 mb-2">
            Debt Settlement Module - Coming Soon
          </h2>
          <p className="text-purple-700 dark:text-purple-400 max-w-md mx-auto">
            This module will allow you to manage debt settlement cases, track negotiations with creditors,
            and monitor settlement progress for your clients.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DebtSettlementDashboard;
